import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: inline-flex;
  width: 100%;
  height: 64px;
  padding: 0 24px;
  background: white;
  box-shadow: 0px 2px 4px rgba(8, 13, 26, 0.15);
  justify-content: space-between;
  align-items: center;

  img {
    width: 115px;
    height: 32px;
  }
`;

export const NavContainter = styled.nav`
  align-self: stretch;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;

  a {
    height: 52px;
    padding: 16px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    border-bottom: 2px solid transparent;

    span {
      color: #858890;
      font-size: 13px;
      font-family: 'Work Sans', sans-serif;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 16px;
      letter-spacing: 1.04px;
      word-wrap: break-word;
    }

    &.active {
      border-bottom: 2px solid #0C2856;

      span {
        color: #0C2856;
      }
    }

    &:hover span {
      color: #0C2856;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  padding-right: 2rem;
  justify-content: flex-end;
  padding: 1.3rem;
  cursor: pointer;

  svg {
    width: 2.2rem;
    height: 2.2rem;
  }

  label {
    cursor: pointer;
    line-height: 21px;
    font-size: 1.3rem;
    letter-spacing: 2px;
    color: ${({ theme }) => theme.colors.grayLight};
  }

  &:hover {
    label {
      text-decoration: underline;
    }
  }
`;
